import React, { useEffect, useRef, useState } from 'react'
import "./events.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router';
import eventData from "../../../../src/data/events.json";


function C2wEventsHome() {
  const swiperRef = useRef(null);
  const navigate=useNavigate();

  // useEffect(() => {
  //   fetch("/data/events.json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setCourseData(data.events)
  //     })
  //     .catch((err) => {
  //     });
  // }, []);


  // Functions to navigate slides
  const goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const goToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };


  return (
    <div className='C2wEventsHome'>
      <div className='C2wEventsHome_conatiner'>
        <div className='C2wEventsHome_containt_container'>
          <div className='C2wEventsHome_header_container'>
            <h1><span>Events</span> & Activities</h1>
            <div className="C2wEventsHome_slide_buttons">
              <div className='C2wEventsHome_slide_btn' onClick={goToPrevSlide}><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              </div>
              <div className='C2wEventsHome_slide_btn' onClick={goToNextSlide}><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              </div>
            </div>
          </div>
          <div className='C2wEventsHome_events_container'>
            <div className='C2wEventsHome_events_swiper_container'>
              <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                // modules={[Autoplay]}
                slidesPerView={4.5}
                loop={Infinity}
                // centeredSlides={true}
                speed={2000}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                pagination={{ clickable: true }}
                className='myPlacementsSwiper'
                breakpoints={{
                  360: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 25,
                  },
                  1340: {
                    slidesPerView: 4,
                    spaceBetween: 90,
                  },
                  1366: {
                    slidesPerView: 4,
                    spaceBetween: 70,
                  },
                  1440: {
                    slidesPerView: 3.5,
                    spaceBetween: 25,
                  },

                  1536: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                  },

                  1540: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                  },
                  1920: {
                    slidesPerView: 4.5,
                    spaceBetween: 15,
                  },
                }}

              >{
                  eventData?.events && eventData?.events?.map((event) =>
                    <SwiperSlide>
                      <div className='C2wEventsHome_events_image_container' onClick={()=>{navigate(`/event-details/${event.slug}`)}}>
                        <img src={event.coverImage} alt='eventImage' />
                        <div className='C2wHome_event_card_darkbackground' />
                        <div className='C2wHome_event_card_background' />
                        <div className='C2w_event_containt_container'>
                          <div className='C2w_event_text_containt'>
                            <div className='C2w_event_heading'>{event.name}</div>
                            <div className='C2w_event_date'>{event.year}</div>
                          </div>
                          <div className='C2wEvent_route_btn' >
                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.26769 6.56055L12.7383 6.56055" stroke="#1675F2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.44416 1.26563L12.7383 6.55974L7.44416 11.8539" stroke="#1675F2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>)
                }

               
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default C2wEventsHome;
